//firebasejs

import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getAuth, signInAnonymously} from "firebase/auth";
import { getFunctions } from "firebase/functions";

// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyCvYoudnA-6LHHNH18Q8ePqFK9ZwGsmiRs",
  authDomain: "myapp-cbe4b.firebaseapp.com",
  projectId: "myapp-cbe4b",
  storageBucket: "myapp-cbe4b.firebasestorage.app",
  messagingSenderId: "710590239849",
  appId: "1:710590239849:web:67a45b7f1a068f7f1d7ef8",
  measurementId: "G-K0Q6GF0R83"
};

// Initialize Firebase
// const analytics = getAnalytics(app);

const app = initializeApp(firebaseConfig);
const db = getFirestore(app);
const auth = getAuth(app);
signInAnonymously(auth).catch(console.error);
export const functions = getFunctions(app);

export { db, auth };